import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import API from '../shared/forms/API';
import LoadingView from '../shared/LoadingView';
import { FIELD_DEFINITIONS } from './fieldDefinitions';

const summarize = (value) => {
  if (value === undefined || value === null) return null;
  if (value.length === 0) return '(leeg)';
  if (value.length <= 60) return value;
  return value.slice(0, 57) + '…';
};

export default class NotificationConfigDetailPageView extends Component {
  state = {
    item: null,
    locations: null,
    settingsByLocation: null,
    selectedLocation: '',
  };

  componentDidMount() {
    this.load();
  }

  async load() {
    const slug = this.props.match.params.slug;
    try {
      const [item, locationsResp] = await Promise.all([
        new API().fetch(`settings/notification-catalog/${slug}`).then((r) => r.json()),
        new API().fetch('locations?limit=500').then((r) => r.json()),
      ]);
      const settingsByLocation = await this.fetchAllSettings(item);
      this.setState({
        item,
        locations: locationsResp.results || [],
        settingsByLocation,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async fetchAllSettings(item) {
    const targets = ['', ...item.locationOverrides];
    const result = {};
    await Promise.all(
      targets.map(async (location) => {
        const fields = {};
        await Promise.all(
          item.fields.map(async (field) => {
            const key = location ? `${item.baseKey}.${location}` : item.baseKey;
            const r = await new API().fetch(`settings/${field}/${key}`);
            if (r.ok) fields[field] = await r.json();
          })
        );
        result[location] = fields;
      })
    );
    return result;
  }

  handleAddOverride = (event) => {
    event.preventDefault();
    if (!this.state.selectedLocation) return;
    const slug = this.props.match.params.slug;
    this.props.history.push(
      `/notification-config/${slug}/edit/${encodeURIComponent(this.state.selectedLocation)}/`
    );
  };

  availableLocations() {
    const used = new Set(this.state.item.locationOverrides);
    return (this.state.locations || [])
      .filter((loc) => loc.enabled !== false && !used.has(loc.name))
      .map((loc) => loc.name)
      .sort();
  }

  renderRow(location) {
    const { item, settingsByLocation } = this.state;
    const settings = settingsByLocation[location || ''] || {};
    const slug = this.props.match.params.slug;
    const editPath = location
      ? `/notification-config/${slug}/edit/${encodeURIComponent(location)}/`
      : `/notification-config/${slug}/edit/`;

    return (
      <tr key={location || '__default__'}>
        <td className="align-middle">
          {location ? (<>
              <i className="fa fa-map-marker mr-2 text-muted" />
              {location}
            </>
          ) : "Standaard"}
        </td>
        {item.fields.map((field) => {
          const setting = settings[field];
          return (
            <td className="align-middle" key={field}>
              {setting ? (
                <span title={setting.value}>{summarize(setting.value)}</span>
              ) : (
                <span className="text-muted">
                  {location ? 'Gebruikt standaard' : 'Niet ingesteld'}
                </span>
              )}
            </td>
          );
        })}
        <td className="align-middle text-right text-nowrap">
          <Link to={editPath} className="btn btn-sm btn-secondary">
            <i className="fa fa-pencil mr-1" /> Bewerken
          </Link>
        </td>
      </tr>
    );
  }

  renderContent() {
    const { item } = this.state;
    const overrides = [...item.locationOverrides].sort();
    const available = this.availableLocations();

    return (
      <Fragment>
        <h4>{item.name}</h4>
        <p className="small">{item.description} ({item.baseKey})</p>
        <table className="table my-4">
          <thead>
            <tr>
              <th style={{width: '20%'}}>Locatie</th>
              {item.fields.map((field) => (
                <th key={field}>
                  {(FIELD_DEFINITIONS[field] || {}).title || field}
                </th>
              ))}
              <th style={{width: '180px'}}/>
            </tr>
          </thead>
          <tbody>
            {this.renderRow(null)}
            {overrides.map((loc) => this.renderRow(loc))}
          </tbody>
        </table>
        {available.length > 0 && (
          <div className="card bg-light">
            <div className="card-body">
              <form className="form-inline" onSubmit={this.handleAddOverride}>
                <label className="mr-2" htmlFor="add-override-location">
                  Tekst instellen voor
                </label>
                <select
                  id="add-override-location"
                  className="form-control mr-2"
                  value={this.state.selectedLocation}
                  onChange={(e) => this.setState({selectedLocation: e.target.value})}
                >
                  <option value="">- Kies locatie -</option>
                  {available.map((name) => (
                    <option key={name} value={name}>
                      {name}
                    </option>
                  ))}
                </select>
                <button
                  className="btn btn-primary"
                  disabled={!this.state.selectedLocation}
                >
                  <i className="fa fa-plus mr-1"/> Toevoegen
                </button>
              </form>
            </div>
          </div>
          )}
      </Fragment>
    );
  }

  render() {
    const ready = this.state.item !== null && this.state.settingsByLocation !== null;
    return (
      <div>
        <nav className="navbar navbar-expand navbar-light bg-light">
          <div className="navbar-brand">Notificatie templates</div>
        </nav>
        <div className="container-fluid my-4">
          {ready ? this.renderContent() : <LoadingView />}
        </div>
      </div>
    );
  }
}
